import {Component, OnInit} from '@angular/core';
import {HeaderComponent} from '../header/header.component';
import {RouterOutlet} from '@angular/router';
import {FooterComponent} from '../footer/footer.component';

@Component({
    selector: 'app-admin-layout',
    template: `
        <div class="min-h-screen flex flex-col">
            <app-admin-header></app-admin-header>
            <div class="main flex-1 justify-center">
                <router-outlet></router-outlet>
            </div>
            <footer class="pt-4">
                <app-footer></app-footer>
            </footer>
        </div>`,
    styles: [],
    imports: [
        HeaderComponent,
        RouterOutlet,
        FooterComponent
    ],
    standalone: true
})
export class LayoutComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }
}
